// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.learning-courselist {
    max-width: 1020px;
}

.learning-courselist-item {
    background-color: var(--colorPanel);
    padding: 16px 4px;
    overflow: hidden;
}

.learning-courselist-item-mobile {
    background-color: var(--colorPanel);    
}

.learning-courselist-item-image {
    width: 118px !important;
    height: 66px !important;
    overflow: hidden;
    margin-right: 8px !important;
}

.learning-courselist-info {
    max-width: 800px;
}

.learning-courselist-item-mobile div.MuiChip-root {
    max-width: 40vw;
}

.learning-course-grid .MuiCardMedia-root {
  transform: scale(0.9);
  margin-top: 5px;
}

`, "",{"version":3,"sources":["webpack://./../../../Components/Module/LearningActivityItem/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".learning-courselist {\r\n    max-width: 1020px;\r\n}\r\n\r\n.learning-courselist-item {\r\n    background-color: var(--colorPanel);\r\n    padding: 16px 4px;\r\n    overflow: hidden;\r\n}\r\n\r\n.learning-courselist-item-mobile {\r\n    background-color: var(--colorPanel);    \r\n}\r\n\r\n.learning-courselist-item-image {\r\n    width: 118px !important;\r\n    height: 66px !important;\r\n    overflow: hidden;\r\n    margin-right: 8px !important;\r\n}\r\n\r\n.learning-courselist-info {\r\n    max-width: 800px;\r\n}\r\n\r\n.learning-courselist-item-mobile div.MuiChip-root {\r\n    max-width: 40vw;\r\n}\r\n\r\n.learning-course-grid .MuiCardMedia-root {\r\n  transform: scale(0.9);\r\n  margin-top: 5px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
